module.exports = __webpack_public_path__ + "static/img/group01.11496f03.png";